import ForgotPassword from "../pages/auth/ForgotPassword";

export const API_URL = "https://magrudyadminapi.appgrowthcompany.com/";
// export const API_URL = 'http://localhost:6051/';
export const END_POINTS = {
  login: "/admin/onboarding/login",
  upload: "media",
  sendOtp: "admin/onboarding/send-otp/",
  get_user: "admin/onboarding",
  logout: "/admin/onboarding/logout",
  verifyOtp: "/admin/onboarding/verifyOtp",
  changePassword: "/admin/onboarding/changePassword",
  forgotPassword: "/admin/onboarding/forgotPassword",
  resetPassword: "/admin/onboarding/resetPassword",
  updateProfile: "/admin/onboarding",
  uploadMedia: "admin/media",
  questionnaire: "admin/questionnaire",
  category: "admin/category",
  storeType: "admin/storeType",
  bagCategory: "admin/bagCategory",
  //manage-users
  users: "admin/users/list",
  addUser: "admin/users",
  usersExport: "admin/users/export",
  usersTransactions: "admin/users/transactions",

  //manage-categories
  getCategories: "admin/get-all-manage-user/",
  getCategryById: "admin/get-manage-user/",
  updateCategories: "admin/update-manage-user/",
  changeCategryStatus: "admin/update-manage-user-status/",
  deleteCategry: "admin/delete-manage-user/",
  exportCategories: "/admin/csv-users",

  //cms
  getCms: "admin/cms",
  updateCmsContact: "admin/add-contact-suport/",
  updateCmsTerms: "admin/add-terms-condition/",
  updateCmsPrivacy: "admin/add-privacy-policy/",
  updateCmsAbout: "admin/add-about-us/",
  updateCms: "admin/arabic-cms/",

  //faq
  getFaqs: "admin/cms/listFaqs",
  getFaq: "admin/cms/faqs",

  //subadmin roles
  addsubAdminRole: "admin/subadminaccess/",
  getSubAdminRole: "admin/subadminaccess/",
  deleteSubAdminRole: "admin/subadminaccess/",
  updateSubAdminRole: "admin/subadminaccess/",

  //subadmin
  subadmin: "admin/subadmin/",
  //dashboard
  dashboardData: "admin/get-dashboard-data/",
  pointsDashboardAll: "admin/users/pointsDashboardAll",
  notificationsDashboard: "admin/users/notificationsDashboard",
  pointsActivity: "admin/users/pointsActivity",
  notificationsSentVsOpened: "admin/users/notificationsSentVsOpened",
  topCustomers: "admin/users/topCustomers",
  sessionsActivity: "admin/users/sessionsActivity",
  dailyUsageReports: "admin/users/dailyUsageReports",
  transactionsDashboard: "admin/users/transactionsDashboard",
  upcomingBirthdayList: "admin/users/upcomingBirthdayList",
  birthdayNotificationsList: "admin/users/birthdayNotificationsList",
  //promo code
  promocode: "admin/promocode",

  //role
  accessRole: "/admin/access-role",
  store: "admin/store/",
  bag: "admin/bag/",
  currency: "admin/currency/",
  categories: "admin/category/",
  getMultiplier: "admin/currencyRate/multiplier/",

  // campaign
  campaign: "admin/campaign",

  // banner
  banner: "admin/banner",

  //home section
  homeSection: "admin/banner/homesection",
  settings: "admin/settings",

  //Topics & Categories
  subCommunityCategory: "admin/subCommunityContentCategory",
  addTopic: "admin/community/create-topic",
  updateTopic: "admin/community/topics",
  getTopics: "admin/community/topics",
  deleteTopic: "admin/community/topics",
  getTopicById: "admin/community/topics",

  //Events & Activities
  event: "admin/event",

  // deleteEvent :"",
  announcement: "admin/announcements",

  //orders
  orders: "admin/bookings",

  //promotions
  promotions: "admin/rewardpromotions",
  listReactions: "admin/rewardpromotions/listReactions",
  //Setting
  addSetting: "admin/setting",
  updateSetting: "admin/setting",
  getSettings: "admin/setting",

  // email template
  emailtemplate: "admin/emailtemplate",

  //notification
  notification: "admin/notification",
  getNotification: "admin/notification/globalNotification",
  getNotificationDetails: "admin/notification/getNotificationById",

  //transactions
  transactions: "admin/users/transactions",
  exportUserReport: "admin/users/exportUserReport",
  exportTransactions: "admin/users/exportTransactions",

  //Feedback Reports & Logs
  feedbacks: "admin/rewardpromotions/listReactions",
  //bulk upload
  bulkUpload: "admin/store/bulkLoad",
  logs: "admin/users/listLogs",

  //
  userReport: "admin/users/userReport",
};
